import { Dialog } from "@mui/material"
import CloseButton from "common/CloseButton"
import dynamic from "next/dynamic"
import styled from "styled-components"

const YouTubePlayer = dynamic(() => import("common/YouTubePlayer"), {
  loading: () => <p>...</p>,
})

const StyledCloseButton = styled(CloseButton)`
  :focus {
    color: ${(p) => p.theme.colors.white};
    border: 1px solid ${(p) => p.theme.colors.white};
  }
`
const StyledContainer = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 50px 10px 10px;
`

const StyledVideo = styled(YouTubePlayer)`
  max-width: 100%;
  width: 100%;
`

type VideoPopUpProps = {
  url: string
  open: boolean
  onClose: () => void
  label: string
}

const VideoPopUp = ({ url, open, onClose, label }: VideoPopUpProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    PaperProps={{
      style: {
        backgroundColor: "transparent",
        maxWidth: "fit-content",
        width: "100%",
        boxShadow: "none",
      },
    }}
    aria-label={label}
    disableAutoFocus={false}
    role="dialog"
    aria-modal="true"
    tabIndex={-1}
  >
    <StyledContainer role="dialog" aria-modal={true} tabIndex={-1}>
      <StyledCloseButton
        color="secondary"
        onClick={onClose}
        aria-label="close window"
      />
      <StyledVideo url={url} noMargin />
    </StyledContainer>
  </Dialog>
)

export default VideoPopUp
